import useReactRouter from 'use-react-router';
import getValue from 'lodash/get';

import { useCompanyInfoCheckListQuery } from 'generated/credit-analysis-graphql';
import { ApolloClientName } from 'apollo-client-factory';
import { RouteParams } from 'components/custom-route/custom-route';
import { useGetLoanQuery } from 'generated/graphql';

type PartnerDocumentRouteParams = RouteParams & {
    signerId: string;
};

const useSignerDocumentInfo = () => {
    const { match: { params: { loanApplicationId, signerId } } } = useReactRouter<PartnerDocumentRouteParams>();
    const { data: loanInfo, loading: loadingLoanInfo } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });
    const { data: { companyInfo }, loading: loadingChecklist } = useCompanyInfoCheckListQuery({
        variables: { loanApplicationId },
        context: { clientName: ApolloClientName.CreditAnalysisApi },
    });

    return {
        loading: loadingLoanInfo || loadingChecklist,
        signerId,
        loanApplicationId,
        signerName: companyInfo.signers.find(s => s.id === signerId).name,
        applicantName: getValue(loanInfo, 'loanApplication.borrower.responsibleName', '-'),
        productBizId: getValue(loanInfo, 'loanApplication.product.bizId', null),
        isCompleted: companyInfo.signers.find(s => s.id === signerId).checklist.isCompleted,
    }
};

export default useSignerDocumentInfo;
